import React from 'react';
import * as style from './style.css';
import { IconMapBus16, IconMapHighway16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import { Body1 } from '@cian/ui-kit';
import { ITransportPointExtended } from '../../../../../../../types/newbuildingsCompare';
import { metroIconMapper } from '../mapper';

interface ITransportPointRowProps {
  item: ITransportPointExtended;
}

export const TransportPointRow = ({ item }: ITransportPointRowProps): React.JSX.Element => {
  const isWalk = item.transportDistance?.transportType === 'walk';
  const isMetro = item.type === 'underground';
  const iconStyle = React.useMemo(() => ({ color: `#${item.color}` }), [item.color]);

  return (
    <span className={style['transport-row']} key={item.name}>
      <div style={iconStyle} className={style['icon-container']}>
        {isMetro ? metroIconMapper(item.undergroundType) : <IconMapHighway16 />}
      </div>
      <Body1 color="text-primary-default">{item.name}</Body1>
      {isWalk ? <IconMapWalk16 /> : <IconMapBus16 />}
      <Body1 color="text-secondary-default">{item.transportDistance?.distance}</Body1>
    </span>
  );
};
